import { render, staticRenderFns } from "./DemoRangeSliderColor.vue?vue&type=template&id=783858f2&"
import script from "./DemoRangeSliderColor.vue?vue&type=script&lang=js&"
export * from "./DemoRangeSliderColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
installComponents(component, {VRangeSlider})
